export default {
  computed: {
    // CHECKBOX SUBSETTINGS
    modulesSubSettingsRaw() {
      return {
        BILLINGS: [
          {
            name: 'billings_legalization_enabled',
            titlePath: 'admin.billingsLegalizationEnabled',
          },
          {
            name: 'billings_water_dissolution_dma_zone_enabled',
            titlePath: 'admin.billingsWaterDissolutionEnabled',
          },
          {
            name: 'billings_water_dissolution_watermeters_enabled',
            titlePath: 'admin.billingsWaterDissolutionWatermetersEnabled',
          },
          {
            name: 'billings_anomaly_detection_enabled',
            titlePath: 'admin.billingsAnomalyDetectionEnabled',
          },
          {
            name: 'billings_water_usage_analysis_enabled',
            titlePath: 'admin.billingsWaterUsageAnalysis',
          },
        ],
        FAILURES: [
          {
            name: 'failures_cutoff_enabled',
            titlePath: 'admin.failuresCutoffEnabled',
          },
          {
            name: 'failures_dispatcher_enabled',
            titlePath: 'admin.failuresDispatchedEnabled',
          },
          {
            name: 'failures_cutoff_deaeration_enabled',
            titlePath: 'admin.failuresCutoffDeaerationEnabled',
          },
        ],
        LOCATION_LAB: [
          {
            name: 'location_lab_edit_enabled',
            titlePath: 'admin.locationLabEnlargement',
            subtitlePath: 'admin.locationLabEnlargementSubtitle',
          },
        ],
        WATER_MODELING: [
          {
            name: 'epanet_calibration_data_enabled',
            titlePath: 'admin.calibrationFilesGeneration',
          },
          {
            name: 'epanet_run_analysis_enabled',
            titlePath: 'admin.epanetModelAnalysis',
          },
          {
            name: 'epanet_profiles_enabled',
            titlePath: 'admin.epanetProfiles',
          },
          {
            name: 'epanet_fire_fighting_enabled',
            titlePath: 'admin.fireSimulation',
          },
          {
            name: 'epanet_daily_usage_from_watermeters_attribute',
            titlePath: 'admin.epanetSelectAttributes',
          },
          {
            name: 'epanet_cutoff_enabled',
            titlePath: 'admin.epanetCutoffModeling',
          },
          {
            name: 'epanet_dma_junctions_demand_enabled',
            titlePath: 'admin.epanetDmaJunctionsDemand',
          },
          {
            name: 'water_modeling_ekart_export_enabled',
            titlePath: 'admin.waterModelingEkartExport',
          },
          {
            name: 'epanet_water_quality_enabled',
            titlePath: 'admin.waterModelingWaterQuality',
          },
          {
            name: 'water_modeling_datasource_export_enabled',
            titlePath: 'admin.waterModelingDataSourceExport',
          },
        ],
        SEWER_ANALYSIS: [
          {
            name: 'sewer_congestion_enabled',
            titlePath: 'admin.sewerCongestion',
          },
          {
            name: 'sewer_upstream_sewage_volume_enabled',
            titlePath: 'admin.upstreamSewageVolume',
          },
          {
            name: 'sewer_upstream_sewage_outpouring_enabled',
            titlePath: 'admin.upstreamSewageOutpouring',
          },
        ],
        WATER_BALANCE_MODULE: [
          {
            name: 'water_balance_balance_enabled',
            titlePath: 'admin.waterBalanceZone',
          },
          {
            name: 'water_balance_dma_enabled',
            titlePath: 'admin.waterBalanceDma',
          },
          {
            name: 'water_balance_iwa_enabled',
            titlePath: 'admin.waterBalanceIwa',
            value: true,
          },
          {
            name: 'water_balance_iwa_demand_from_water_usage',
            titlePath: 'admin.waterBalanceIwaDemandWaterUsage',
            value: true,
          },
          {
            name: 'water_balance_reports_enabled',
            titlePath: 'admin.waterBalanceReports',
            value: true,
          },
        ],
        WATER_NETWORK_DEVELOPMENT_MODULE: [
          {
            name: 'epanet_junctions_demand_enabled',
            titlePath: 'admin.quickCheck',
          },
          {
            name: 'epanet_development_planning_enabled',
            titlePath: 'admin.developmentPlanning',
          },
        ],
        ADVANCED_DIGITIZING: [
          {
            name: 'split_merge_polygons_enabled',
            titlePath: 'admin.advancedDigitizing.splitMergePolygons',
          },
          {
            name: 'snapping_config_enabled',
            titlePath: 'admin.advancedDigitizing.snappingConfigEnabled',
          },
          {
            name: 'split_line_half_enabled',
            titlePath: 'admin.advancedDigitizing.splitLineHalf',
          },
          {
            name: 'move_rotate_geometry_enabled',
            titlePath: 'admin.advancedDigitizing.moveRotateGeometryEnabled',
          },
          {
            name: 'precise_digitizing_enabled',
            titlePath: 'admin.advancedDigitizing.preciseDigitizing',
          },
        ],
        AQUAGIS_MOBILE: [
          {
            name: 'signature_attachment_enabled',
            titlePath: 'admin.signatureAttachment',
            subtitlePath: 'admin.mobileAppToolSubtitle',
          },
          {
            name: 'login_offline_mobile_enabled',
            titlePath: 'admin.loginOffline',
            subtitlePath: 'admin.mobileAppToolSubtitle',
          },
        ],
        PRINTING_2_MODULE: [
          {
            name: 'serial_printing_2_enabled',
            titlePath: 'admin.serialPrinting',
          },
          {
            name: 'ribbon_printing_2_enabled',
            titlePath: 'admin.ribbonPrinting',
          },
        ],
        FORM_PRINT: [
          {
            name: 'scl_greenfields_enabled',
            titlePath: 'admin.generateSclGreenfield',
          },
          {
            name: 'scl_greenfields_2_enabled',
            titlePath: 'admin.generateSclGreenfieldv2',
          },
          {
            name: 'scl_brownfields_enabled',
            titlePath: 'admin.generateSclBrownfield',
          },
          {
            name: 'form_print_legnica_pdf_enabled',
            titlePath: 'admin.generateLegnica',
          },
          {
            name: 'form_print_masterplan_2_squares_pdf_enabled',
            titlePath: 'admin.generateMasterplanSquares',
          },
          {
            name: 'form_print_masterplan_2_illuminations_pdf_enabled',
            titlePath: 'admin.generateMasterplanIlluminations',
          },
          {
            name: 'form_print_masterplan_2_streets_pdf_enabled',
            titlePath: 'admin.generateMasterplanStreets',
          },
          {
            name: 'form_print_lodz_pdf_enabled',
            titlePath: 'admin.generateLodz',
          },
          {
            name: 'form_print_ksse_pdf_enabled',
            titlePath: 'admin.generateKsse',
          },
          {
            name: 'scl_halls_offices_enabled',
            titlePath: 'admin.generateSclHallsOffices',
          },
        ],
        SEND_MESSAGE_MODULE: [
          {
            name: 'send_message_sms_superadmin_cc_enabled',
            titlePath: 'admin.sendSmsCopy',
          },
          {
            name: 'send_message_email_superadmin_cc_enabled',
            titlePath: 'admin.sendEmailCopy',
          },
          {
            name: 'send_message_templates_superadmin_enabled',
            titlePath: 'admin.sendEmailSmsConfiguration',
          },
        ],
        BASIC_TOOLS_MODULE: [
          {
            name: 'basic_tools_v1_enabled',
            titlePath: 'admin.copyFeatures1',
          },
          {
            name: 'basic_tools_v2_enabled',
            titlePath: 'admin.copyFeatures2',
          },
        ],
        GOOGLE_MAPS: [
          {
            name: 'street_view_tool_enabled',
            titlePath: 'admin.streetView',
          },
          {
            name: 'google_maps_tool_enabled',
            titlePath: 'admin.googleMaps',
          },
        ],
      };
    },
    modulesSubSettings() {
      return Object.keys(this.modulesSubSettingsRaw).reduce((total, current) => {
        return {
          ...total,
          [current]: this.modulesSubSettingsRaw[current].sort((a, b) =>
            this.$i18n.t(a.titlePath).localeCompare(this.$i18n.t(b.titlePath))
          ),
        };
      }, {});
    },

    // INPUT SETTINGS
    modulesSettingsRaw() {
      return {
        AQUAGIS_MOBILE: [
          {
            name: 'mobile_identification_zoom_level',
            dataType: { name: 'integer' },
            translationPath: 'admin.mobileIdentificationZoomLevel',
          },
          {
            name: 'mobile_labels_zoom_level',
            dataType: { name: 'integer' },
            translationPath: 'admin.mobileLabelsZoomLevel',
          },
        ],
      };
    },
    modulesSettings() {
      return Object.keys(this.modulesSettingsRaw).reduce((total, current) => {
        return {
          ...total,
          [current]: this.modulesSettingsRaw[current].sort((a, b) =>
            this.$i18n.t(a.titlePath).localeCompare(this.$i18n.t(b.titlePath))
          ),
        };
      }, {});
    },
  },
};
